<template>
  <div class="progress-container payment-indicator">
    <div
      class="payment-indicator"
      :style="indicatorStyles"
      id="payment-indicator"
    >
      <span class="payment-indicator-text" :style="textStyles">
        {{ indicatorText }}
      </span>
      
    </div>
    <div class="indicator-footer">
      <span v-if="isPending">
        {{
          $t(
            "message.pleaseDoNotRefreshYourBrowserWhilePaymentIsBeingProcessed"
          )
        }}.
      </span>
      <strong v-if="error">{{ error }}</strong>
    </div>
    <div v-if="error" style="margin-top: 10rem" class="text-center">
      <div>
        <span>Already Paid on Liven App?</span>
      </div>
      <div class="mt-3">
        <button
          type="button"
          class="btn btn-dark"
          @click="reloadPage"
        >
          Try Again
        </button>
      </div>
      <div class="mt-3">
        <span>If you are still facing an issue</span>
      </div>
      <div>
        <span>please contact the staff.</span>
      </div>
    </div>
    <div style="margin-top: 12rem">
      <poweredby />
    </div>
  </div>
</template>
  
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { logger } from '../../../api/Logger';
import { DefaultPaymentHandler } from '../../../api/payment/DefaultPaymentHandler';
import { getTrackingOrderData } from '../../../api/services/orderService';
import { getTempOrder } from '../../../api/services/storeService';
import { DetectBrand } from '../../../mixins/brandDetector';
import poweredby from "../../shared/poweredby";
import { removeOrder, updateOrderStatus, removeUser } from '../../../api/helpers/rtdbHelper';
export default {
  name: 'PaymentSuccess',
  components: {
    poweredby,
  },
  data() {
    return {
      isPending: true,
      succeeded: false,
      storeID: '',
      orderID: '',
      error: '',
    };
  },
  async mounted() {
    setTimeout(() => {
      if (this.isPending) {
        logger.logObject(
          {
            storeID: this.storeID,
            orderID: this.orderID,
            error: this.error,
            isPending: this.isPending,
            succeeded: this.succeeded,
          },
          'liven',
          'error'
        );
        this.$router.go();
      }
    }, 8000);
    try {
      if (this.$route.query) {
        this.storeID = this.$route.query.storeID;
        this.orderID = this.$route.query.orderID;
        // check if order is already created for non branded store
        if (!DetectBrand.methods.isBranded) {
          const data = await getTrackingOrderData(null, this.orderID, this.storeID);
          if (data) {
            this.succeeded = true;
            this.isPending = false;
            this.navigateSuccess(
                data.UDID,
                data.OnlineOrderUserIdentifier || data.GuestUserIdentifier,
                false,
              );
            return;
          }
        }
        this.setStore(this.storeID);
        this.initStore({
          storeId: this.storeID,
        });
        const tempOrder = await getTempOrder(this.storeID, this.orderID);

        if(!tempOrder || !tempOrder.exists) {
          this.error = 'No associated order for the payment';
          this.isPending = false;
          return;
        }
        const orderData = tempOrder.data();
        // for branded store check if order is already created
        if (DetectBrand.methods.isBranded) {
          const userID = orderData.Order.TrackingOrder.GuestUserIdentifier || orderData.Order.TrackingOrder.OnlineOrderUserIdentifier;
          const storeData = await getTrackingOrderData(userID, this.orderID, this.storeID);
          if (storeData) {
            this.succeeded = true;
            this.isPending = false;
            this.navigateSuccess(
                storeData.UDID,
                storeData.OnlineOrderUserIdentifier || storeData.GuestUserIdentifier,
                false,
              );
            return;
          }
        }

        const cf = new DefaultPaymentHandler();
        const createdOrder = await cf.MakePayment(orderData.Order.TrackingOrder.UDID, orderData.Order);
        if (!createdOrder.data.Success) {
          this.error = createdOrder.data.Status ? createdOrder.data.Status.Message : 'Please complete the liven payment';
          this.isPending = false;
          return;
        }
        this.succeeded = true;
        this.isPending = false;
        setTimeout(() => {
          const trackingOrder = orderData.Order;
            this.navigateSuccess(
              trackingOrder.TrackingOrder.UDID,
              trackingOrder.TrackingOrder.OnlineOrderUserIdentifier || trackingOrder.TrackingOrder.GuestUserIdentifier,
              false,
            );
        }, 1000);
      } else {
          this.error = 'Something went wrong! please try again';
          this.isPending = false;
          return;
        }
    } catch (error) {
      logger.log('liven', error, '/paymentsuccess', 'error', null, 'liven');
      this.error = 'Something went wrong! please try again';
      this.isPending = false;
      return
    } finally {
      this.isPending = false;
    }
  },
  computed: {
    ...mapGetters(["desktopStyles", "viewConfig", "showSharedCart", "getSharedCartProps", "getSharedCartSingleOrder"]),
    indicatorStyles() {
      if (this.isPending) {
        return {
          backgroundImage: `url(${require("../../../assets/indicators/payment-processing-circle.gif")})`,
          url: '../'
        };
      } else if (this.succeeded) {
        return {
          backgroundImage: `url(${require("../../../assets/indicators/payment-success-circle.svg")}), url(${require("../../../assets/indicators/payment-success-tick.svg")})`,
          backgroundPosition: "center 25px, center 72px",
        };
      } else {
        return {
          backgroundImage: `url(${require("../../../assets/indicators/payment-failure-circle.svg")}), url(${require("../../../assets/indicators/payment-failure-close.svg")})`,
          backgroundPosition: "center 25px, center 66px",
        };
      }
    },
    indicatorText() {
      return this.isPending
        ? this.$t("message.processingPayment")
        : this.succeeded
        ? this.$t("message.paymentComplete")
        : this.$t("message.paymentCouldNotBeProcessed");
    },
    textStyles() {
      let color = "#0049CE";
      color = this.isPending
        ? "#0049CE"
        : this.succeeded
        ? "#00A806"
        : "#F44336";

      return { color, flex: "100% 1 0" };
    },
    buttonStyles() {
      return {
        ...this.desktopStyles.btn,
        ...this.desktopStyles.desktopPlaceOrderButton,
        marginTop: "25px",
        marginBottom: "-75px !important",
      };
    },
  },
  methods: {
    ...mapMutations([ "setStore" ]),
    ...mapActions([ "initStore", "clearCart" ]),
    reloadPage() {
      this.error = false;
      this.isPending = true;
      this.$router.go();
    },
    navigateSuccess(udid, userid, CreateUserForGuest) {
      this.clearCart();
      if (this.showSharedCart) {
        const { user, table } = this.getSharedCartProps
        if (!this.getSharedCartSingleOrder) {
            updateOrderStatus(table, this.storeID, { status: "complete" });
            removeOrder(this.storeID, table);
          } else {
            removeUser(user, this.storeID, table);
          }
      }
      if (
        (this.viewConfig.LogIn === false || !this.user) &&
        this.viewConfig.HideTrackingOrderForGuest
      ) {
        this.$router.push({
          name: "thankyou",
          params: {
            storeid: this.storeID,
            storename: this.storeID,
            isGift: false,
          },
        });
      } else {
        this.$router.push({
          name: "completeorder",
          params: {
            storeid: this.storeID,
            storename: this.storeID,
            orderid: udid,
            userid: userid,
            createUserForGuest: CreateUserForGuest,
            selectedCompanyId: this.storeID,
          },
        });
      }
    },
  }
};
</script>
  